module.exports = __webpack_public_path__ + "img/green.eca6a4f1.webp";